import { useCallback, useEffect, useState } from "react";
import { failureSaid } from "./localization/failure.ts";
import { say } from "./localization/say.ts";
import { notSignedIn, read } from "./net/rally.ts";

export type Me = {
  account: string;
  handle: string;

  displayName: string | null;
  avatar?: string;

  role?: string | null;
};

export type Session =
  | { state: "asking" }
  | { state: "signed-in"; me: Me }
  | { state: "signed-out" }
  | { state: "broke"; why: string };

export function useSession(): { session: Session; again: () => void } {
  const [session, setSession] = useState<Session>({ state: "asking" });

  const again = useCallback(() => {
    read<Me>("me")
      .then((me) => setSession({ state: "signed-in", me }))
      .catch((cause: unknown) => {
        if (notSignedIn(cause)) return setSession({ state: "signed-out" });
        setSession({
          state: "broke",
          why: failureSaid(cause, say("failure.serverNoAnswer")),
        });
      });
  }, []);
  useEffect(again, [again]);
  return { session, again };
}
